export default "__VITE_ASSET__rY$YHgpd__"